module.exports = __webpack_public_path__ + "static/media/csv.d5bc601d.png";